export { wrapRootElement } from './src/apollo/wrap';